import { getEnvVariable } from "../../modules/environmentalList";
const drawerexternalnonadmin = {
    "type": "drawer",
    "order": 2,
    "key": "drawer",
    "options": {
        "alignitem": "left",
        // "title": "drawer",
        "icon": "alarm",
        "open": true,
        "anchor": 'left',
        "admin": 'N',
        "items": [{
            "type": "tree",
            "title": "Dashboard",
            "materialicon": "dashboard",
            "key": "Dashboard",
            "items": [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },
                {
                    "type": "menu",
                    "title": "Invoice Dashboard",
                    "icon": "assessment",
                    "materialicon": "assessment",
                    "link": "/billingdashboard",
"reloadtab": true,
                    "key": "billingdashboard",
                    "style": {
                        'color': '#c158dc'
                    }
                },
               

            ]           
        },
        {
            "type": "tree",
            "title": "My Portal",
            "materialicon": "corporate_fare",
            "key": "MyPortal",
            "items": [
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },
                {
                    "type": "recordmenu",
                    "title": "Records",
                    "materialicon": "source",
                    "key": "Records",
                    "items": [],
                    "lskey": "submodule"
                },
                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                
            ]

        },

            // {
            //     "type": "menu",
            //     "title": "Billing",
            //     "key": "billing",
            //     "link": "/billing",
            //     "icon": "fa fa-user-circle-o",
            //     "materialicon": "local_atm",
            //     "style": {
            //         'color': '#d7077a'
            //     }
            // },
            // {
            //     "type": "menu",
            //     "title": "Contacts",
            //     "key": "contacts",
            //     "link": "/Administration/externalcontacts",
            //     "icon": "fa fa-user-circle-o",
            //     "materialicon": "contacts",
            //     "style": {
            //         'color': '#006064'
            //     }
            // }
        ]
    }
}

export default drawerexternalnonadmin